<template>
  <div class="successCases">
    <Nav></Nav>
    <div class="top-img">
      <img :src="cgal" alt=""/>
    </div>
    <div class="contact-us-info">
      <div class="info-wrap">
        <div class="info-left">
          <div class="law-firm">
            <div class="icon-content">
              <img :src="home" alt="律所图标" class="icon">
            </div>
            <span>辽宁玖聚律师事务所</span>
          </div>
          <div class="info-item">
            <div class="icon-content">
              <img :src="address" alt="地址图标" class="icon">
            </div>
            <p>地址：沈阳市浑南区营盘北街3号(409)/(410)</p>
          </div>
          <div class="info-item">
            <div class="icon-content">
              <img :src="tel" alt="电话图标" class="icon">
            </div>
            <p>电话：024-22592535</p>
          </div>
          <div class="info-item">
            <div class="icon-content">
              <img :src="net" alt="网址图标" class="icon">
            </div>
            <p>网址：https://www.lnjiujulaw.cn</p>
          </div>
          <p class="license">律所许可证号：31210000MD0052525D</p>
        </div>
        <div class="info-right">
          <img :src="map" alt="位置地图" class="map-img">
        </div>
      </div>
    </div>
    <footer-con/>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import cgal from '@/assets/img/cgal.png'
import FooterCon from '@/components/footer-con'
import map from '@/assets/img/map.png'
import home from '@/assets/img/home.png'
import address from '@/assets/img/address.png'
import net from '@/assets/img/net.png'
import tel from '@/assets/img/phone.png';

export default {
  name: "contactUs",
  components: {
    Nav,
    FooterCon,
  },
  data() {
    return {
      cgal,
      map,
      home,
      address,
      net,
      tel
    };
  },
  created() {},
  mounted() {},
  methods:{
  }
};
</script>

<style lang="scss" scoped>
.successCases{
  height: 100%; /* 确保父容器高度为 100% */
}


.top-img{
  width: 100%;

  img{
    width: 100%;
    vertical-align: top;
  }
}

.contact-us-info {
  width: 100%;
  background: url(../../assets/img/contactUs_bg.png) no-repeat center;
  background-size: cover; /* 确保背景图填满 */
  padding: 10vh 10vw;
  box-sizing: border-box;
}

.info-wrap {
  display: flex;
  align-items: flex-start;
  margin: 0 auto;
  border-radius: 8px;
  width: 100%;
}

.info-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-sizing: border-box;
  padding: 64px 72px;
}

.law-firm {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}

.law-firm .icon {
  width: 30px;
}

.law-firm span {
  font-weight: 400;
  font-size: 32px;
  color: #333;
  margin-left: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0px;
}

.info-item .icon {
  width: 16px;
}

.info-item p {
  font-size: 16px;
  color: #666;
}

.license {
  font-size: 14px;
  color: #666666;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

.info-right {
  max-height: 426px;
  flex: 0 0 40%;
}
.icon-content{
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
